import { FC, useState } from 'react';
import { Popover } from '@mantine/core';
import styles from './CustomerRefundItem.module.scss';
import { ReactComponent as IconKebab } from './img/iconKebab.svg';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconError } from './img/iconError.svg';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { formatDateWithTime } from 'utils/date';
import { ModalApproveRefund } from 'components/ModalApproveRefund';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';
import { RefundType } from 'redux/Api/refundApi/type';

interface CustomerRefundItemTypes {
  refund: RefundType;
}

export const CustomerRefundItem: FC<CustomerRefundItemTypes> = ({ refund }) => {
  const [opened, setOpened] = useState(false);
  const [showModalApproveRefund, setShowModalApproveRefund] = useState(false);
  const [showSuccessErrorInfo, setShowSuccessErrorInfo] = useState({
    text: '' as string,
    type: 'success' as 'success' | 'error',
  });

  return (
    <div className={styles.root}>
      <p>{refund.id}</p>

      <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        <TextWithTooltip content={refund.customer.type} />
        <div className={styles.root_item__ids}>
          <p className={styles.root_item__id}>ID {refund.customer.id},</p>
          <TextWithTooltip
            content={`ИНН ${refund.customer.inn}`}
            className={styles.root_item__for_ndfl}
          />
        </div>
      </div>
      <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        <TextWithTooltip content={refund.recipient_name} />
        <div className={styles.root_item__ids}>
          <TextWithTooltip
            content={`ИНН ${refund.recipient_inn}`}
            className={styles.root_item__for_ndfl}
          />
        </div>
      </div>

      <p>
        <span>{refund.bank_code}</span>
      </p>
      <p>
        <span>{refund.recipient_account}</span>
      </p>
      <p style={{ textAlign: 'end' }}>{addSpaceNumber(refund.amount)} </p>
      <p style={{ textAlign: 'end' }}>{addSpaceNumber(refund.customer.balance)} </p>
      <p style={{ textAlign: 'end' }}>{addSpaceNumber(refund.customer.hold)} </p>
      <p>
        <span>{refund.is_approved ? <IconDone /> : <IconError />}</span>
      </p>
      <p>
        <span>{refund.is_executed ? <IconDone /> : <IconError />}</span>
      </p>
      <p>
        <span>{formatDateWithTime(refund.created_at)}</span>
      </p>
      {refund.is_approved ? null : (
        <div className={styles.root_kebab}>
          <Popover
            width='fit-content'
            position='bottom-end'
            radius='4px'
            opened={opened}
            onChange={setOpened}>
            <Popover.Target>
              <IconKebab
                className={styles.kebabIcon}
                onClick={() => setOpened((o) => !o)}
              />
            </Popover.Target>
            <Popover.Dropdown
              p='4px 0'
              style={{
                borderRadius: '4px',
                boxShadow: '0px 0px 10px 0px rgba(0, 32, 51, 0.10)',
                border: 'none',
              }}>
              <div
                className={styles.kebabItem}
                onClick={() => {
                  setOpened(false);
                  setShowModalApproveRefund(true);
                }}>
                <span>Подтвердить возврат</span>
              </div>
            </Popover.Dropdown>
          </Popover>
        </div>
      )}
      {showModalApproveRefund && (
        <ModalApproveRefund
          setShow={setShowModalApproveRefund}
          show={showModalApproveRefund}
          customerName={refund.customer.type}
          refundId={refund.id}
          setShowSuccessErrorInfo={setShowSuccessErrorInfo}
        />
      )}
      {showSuccessErrorInfo.text && (
        <SuccessErrorInfo
          text={showSuccessErrorInfo.text}
          type={showSuccessErrorInfo.type}
          handleClose={() => setShowSuccessErrorInfo({ text: '', type: 'success' })}
        />
      )}
    </div>
  );
};
